// all const definition
const backend_port = ":5000"; // define the backend port
export const route_basename = "/"; // for defining the base route for BrowserRouter

// get the backend url
let current_url = "";
if (window.location.href.split(":").length == 2) {
  //frontend url has no port number
  current_url = window.location.href.split("/").slice(0, 3);
  current_url[current_url.length - 1] += backend_port;
  current_url = current_url.join("/");
} else {
  current_url =
    window.location.href.split(":").slice(0, 2).join(":") + backend_port;
}

export const backend_url = current_url + "/"; // eg. "http://localhost:5011/";

export const refresh_token_url = "user_management/refreshUser";

export const primary = "#000038"; // Utility
export const primary_word = "rgba(35,33,118,0.6)"; // Utility
export const secondary = "rgba(247,132,29,0.4)"; // Grid
export const secondary_word = "rgba(247,132,29,1)"; // Grid
export const third = "rgba(184,186,200,1)"; // Grey
export const third_shade = "#dadada";
export const fourth = "rgba(81,152,114,0.2)"; // PV
export const fourth_systemInformation = "#03C19C";
export const fourth_shade_gradient = "#9ce29c";
export const firth = "rgba(59,82,73,0.4)";
export const firth_word = "rgba(59,82,73,1)";

export const borderLine = "rgba(35,33,118,0.5)";
export const red = "#A8312E";
export const green = "#4F8073";

export const FORM_REQUIRED = true;
export const GRID_EMISSION_FACTOR = 0.758;

export const VERIFIER_ROLE_ID = 4;
